
/**
 * Based on https://stackoverflow.com/a/2901298
 * Note: not using lookbehind variation due to lack of support, leading to crashes.
 * 
 * @param {*} x 
 */
export const numberWithDots = (x) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}